﻿import DisclosurePage from "./disclosurePage";
import DisclosureReviewPage from "./disclosureReviewPage";
import DMSActionDuePage from "./dmsActionDuePage";
import DMSWorkflowPage from "./dmsWorkflowPage";
import DMSQuestionnairePage from "./dmsQuestionnairePage";
import DMSValuationMatrixPage from "./dmsValuationMatrixPage";
//TN 20230705
import DMSCostTrackingPage from "./dmsCostTrackingPage";
if (!window.dmsCostTrackingPage) {
    window.dmsCostTrackingPage = new DMSCostTrackingPage();
}
//TN 20230705

if (!window.disclosurePage) {
    window.disclosurePage = new DisclosurePage();
}

if (!window.disclosureReviewPage) {
    window.disclosureReviewPage = new DisclosureReviewPage();
}

if (!window.dmsActionDuePage) {
    window.dmsActionDuePage = new DMSActionDuePage();
}

if (!window.dmsWorkflowPage) {
    window.dmsWorkflowPage = new DMSWorkflowPage();
}

if (!window.dmsQuestionnairePage) {
    window.dmsQuestionnairePage = new DMSQuestionnairePage();
}

if (!window.dmsValuationMatrixPage) {
    window.dmsValuationMatrixPage = new DMSValuationMatrixPage();
}


